import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Upload, FileText, MessageSquare, Video } from 'lucide-react';

const AcademicResourcesFooter = () => {
    const navigate = useNavigate();

    const handleUploadMaterials = () => navigate('/materials');
    const handleCreateAssignments = () => navigate('/assignments');
    const handleDiscussionForum = () => alert('Discussion Forum feature coming soon!');
    const handleVirtualClassroom = () => navigate('/virtual-classroom');

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-40 md:ml-56 lg:ml-64 transition-all duration-300">
            <div className="max-w-7xl mx-auto px-4 py-4 md:px-6">
                <div className="flex flex-col space-y-3">
                    <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider hidden md:block">
                        Academic Resources
                    </h3>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                        <button
                            onClick={handleUploadMaterials}
                            className="flex items-center p-3 md:p-4 border border-gray-200 rounded-xl hover:bg-blue-50 hover:border-blue-200 transition-all duration-200 group text-left bg-gray-50/50"
                        >
                            <div className="flex-shrink-0 mr-3 md:mr-4 bg-white p-2 rounded-lg shadow-sm group-hover:shadow-md transition-shadow">
                                <Upload className="w-5 h-5 md:w-6 md:h-6 text-blue-600" />
                            </div>
                            <div className="flex flex-col">
                                <span className="font-semibold text-gray-900 group-hover:text-blue-700 text-sm md:text-base">Upload Materials</span>
                                <span className="text-xs text-gray-500 hidden lg:block group-hover:text-blue-600/80">Share notes & resources</span>
                            </div>
                        </button>

                        <button
                            onClick={handleCreateAssignments}
                            className="flex items-center p-3 md:p-4 border border-gray-200 rounded-xl hover:bg-green-50 hover:border-green-200 transition-all duration-200 group text-left bg-gray-50/50"
                        >
                            <div className="flex-shrink-0 mr-3 md:mr-4 bg-white p-2 rounded-lg shadow-sm group-hover:shadow-md transition-shadow">
                                <FileText className="w-5 h-5 md:w-6 md:h-6 text-green-600" />
                            </div>
                            <div className="flex flex-col">
                                <span className="font-semibold text-gray-900 group-hover:text-green-700 text-sm md:text-base">Assignments</span>
                                <span className="text-xs text-gray-500 hidden lg:block group-hover:text-green-600/80">Create tasks & quizzes</span>
                            </div>
                        </button>

                        <button
                            onClick={handleDiscussionForum}
                            className="flex items-center p-3 md:p-4 border border-gray-200 rounded-xl hover:bg-purple-50 hover:border-purple-200 transition-all duration-200 group text-left bg-gray-50/50"
                        >
                            <div className="flex-shrink-0 mr-3 md:mr-4 bg-white p-2 rounded-lg shadow-sm group-hover:shadow-md transition-shadow">
                                <MessageSquare className="w-5 h-5 md:w-6 md:h-6 text-purple-600" />
                            </div>
                            <div className="flex flex-col">
                                <span className="font-semibold text-gray-900 group-hover:text-purple-700 text-sm md:text-base">Discussion</span>
                                <span className="text-xs text-gray-500 hidden lg:block group-hover:text-purple-600/80">Student interactions</span>
                            </div>
                        </button>

                        <button
                            onClick={handleVirtualClassroom}
                            className="flex items-center p-3 md:p-4 border border-gray-200 rounded-xl hover:bg-red-50 hover:border-red-200 transition-all duration-200 group text-left bg-gray-50/50"
                        >
                            <div className="flex-shrink-0 mr-3 md:mr-4 bg-white p-2 rounded-lg shadow-sm group-hover:shadow-md transition-shadow">
                                <Video className="w-5 h-5 md:w-6 md:h-6 text-red-600" />
                            </div>
                            <div className="flex flex-col">
                                <span className="font-semibold text-gray-900 group-hover:text-red-700 text-sm md:text-base">Virtual Class</span>
                                <span className="text-xs text-gray-500 hidden lg:block group-hover:text-red-600/80">Host live sessions</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AcademicResourcesFooter;
